import { render } from "./my-work.vue?vue&type=template&id=6e1be032&scoped=true&ts=true"
import script from "./my-work.vue?vue&type=script&lang=ts"
export * from "./my-work.vue?vue&type=script&lang=ts"

import "./my-work.vue?vue&type=style&index=0&id=6e1be032&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1be032"]])

export default __exports__